<template>
  <div>
    <el-dialog title="选择奖品" :visible.sync="dialogVisibleFrom" width="1100px" center @close="dialogClose">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="优惠券" v-if="!isShowFirst" name="first">
          <!-- <el-tabs v-model="listName" type="card" @tab-click="handleClickTwo">
            <el-tab-pane label="店铺内部券" name="first" v-if="!Sans">
              <div class="topTis">
                <i class="el-icon-warning" style="color: #7B61FF; marginright: 8px; font-size: 14px"></i>
                <div class="desc">
                  <p v-if="this.typeDefault.grantType == 3">
                    优惠券类型推荐选择【免费领取】【不公开】【全平台】的优惠券。
                    <el-button style="margin: 0 60px" type="text" @click="jumpCreation">去创建优惠券></el-button>
                  </p>
                  <p v-else>
                    优惠券类型推荐选择【互动平台】的优惠券。
                    <el-button style="margin: 0 60px" type="text" @click="jumpCreation">去创建优惠券></el-button>
                  </p>
                  <p v-if="venderType" style="color: red">
                    抱歉，此类型奖品暂时不支持自营店铺！
                  </p>
                </div>
              </div>
              <input-form
                :inputData="inputData"
                :defaultSelectArr="true"
                @toParentVal="searchForm"
                :btnPosition2="true"
                style="margin: 20px 0;margin-left: -30px;"
              ></input-form>
              <el-table
                v-loading="tableLoading"
                :data="internalTable"
                style="width: 100%"
                :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
                :cell-style="{ 'text-align': 'left' }"
              >
                <el-table-column prop="name" label="名称" width="200"> </el-table-column>
                <el-table-column prop="discount" label="面额" width="120"> </el-table-column>
                <el-table-column prop="quota" label="使用条件" width="120"> </el-table-column>
                <el-table-column label="有效期" width="240">
                  <template slot-scope="scope">
                    <span>起:{{ scope.row.beginTime }}</span
                    ><br />
                    <span>止:{{ scope.row.endTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="类型" width="120">
                  <template slot-scope="scope">
                    <span v-if="scope.row.grantType == 1">促销绑定</span>
                    <span v-if="scope.row.grantType == 2">推送</span>
                    <span v-if="scope.row.grantType == 3">免费领取</span>
                    <span v-if="scope.row.grantType == 4">京豆换券</span>
                    <span v-if="scope.row.grantType == 5">互动平台</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      style="width: 50px;margin-left: -10px;color: #7B61FF;"
                      type="text"
                      class="Notetake"
                      @click="
                        chooseTab(scope.row);
                        dialogVisibleFrom = false;
                      "
                    >
                      选择
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                style="text-align: right; margin-top: 20px"
                @size-change="handleSizeChange"
                background
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 30, 50, 100, 500]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                :current-page="1"
              ></el-pagination>
            </el-tab-pane>
            <el-tab-pane label="店铺外部券" name="second" v-if="!outsideShow">
              <div class="topTis">
                <i class="el-icon-warning" style="color: #7B61FF; marginright: 8px; font-size: 14px"></i>
                <div class="desc">
                  <p>
                    外部优惠券需要手动添加。
                    <el-button type="text" @click="jumpSansCreation">添加外部优惠券></el-button>
                    <br />
                    <span style="line-height: 20px;margin-top: -4px;display: inline-block;">
                      根据平台规定，免费领取优惠券不支持直接发放到买家账号，必须通过链接点击领取，请商家明确活动成本预算，防止优惠券链接被恶意分享的风险；自动发放类型的优惠券可直接发放到用户账户。
                    </span>
                  </p>
                </div>
              </div>
              <input-form
                :defaultSelectArr="true"
                :inputData="inputDataTwo"
                @toParentVal="searchFormTwo"
                :btnPosition2="true"
                style="margin: 20px 0;margin-left: -30px;"
              ></input-form>
              <el-table
                v-loading="tableLoading"
                :data="externalTable"
                style="width: 100%"
                :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
                :cell-style="{ 'text-align': 'left' }"
              >
                <el-table-column prop="name" label="名称"> </el-table-column>
                <el-table-column prop="discount" label="面额" width="100"> </el-table-column>
                <el-table-column prop="quota" label="使用条件" width="100"> </el-table-column>

                <el-table-column label="有效期" width="240">
                  <template slot-scope="scope">
                    <span>起:{{ scope.row.beginTime }}</span
                    ><br />
                    <span>止:{{ scope.row.endTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">

                    <el-button
                      style="width: 50px;margin-left: -10px;color: #7B61FF;"
                      class="Notetake"
                      type="text"
                      @click="
                        chooseTab(scope.row);
                        dialogVisibleFrom = false;
                      "
                    >
                      选择
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                style="text-align: right; margin-top: 20px"
                @size-change="handleSizeChangeTwo"
                background
                @current-change="handleCurrentChangeTwo"
                :page-sizes="[10, 20, 30, 50, 100, 500]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNumTwo"
                :current-page="1"
              ></el-pagination>
            </el-tab-pane>
          </el-tabs> -->

          <div>
            <input-form
              ref="inputForms"
              :inputData="inputDataTwo"
              :btnPosition1="true"
              @toParentVal="searchContentTwo"
            ></input-form>
            <div style="margin: 0px 0px 12px 30px;">
              <el-button
                v-if="venderType"
                style="width: auto;background-color:#7b61ff;color:white;border: 1px solid #7b61ff"
                @click="handleAddCoupon2"
                >添加发放型外部券</el-button
              >
              <el-button v-else style="width: auto;background-color:#7b61ff;color:white;border: 1px solid #7b61ff" @click="handleAddCoupon"
                >创建发放型优惠券</el-button
              >
            </div>
            <!-- v-loading="tableLoading" -->
            <div class="card-point tipBg">
              <div class="card-rule" style="width: 24px;"></div>
              <div class="card-connet">
                <p>因官方接口限制，FCS店铺不支持优惠券奖品，请勿使用优惠券</p>
              </div>
            </div>
            <el-table
              :data="externalTable"
              style="width: 100%"
              :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
              :cell-style="{ 'text-align': 'left' }"
            >
              <el-table-column prop="name" label="优惠券名称" width="150"> </el-table-column>
              <el-table-column prop="couponKind" label="优惠券信息" width="150">
                <template slot-scope="scope">
                  <span v-if="scope.row.couponKind == 0">全品类东券,</span>
                  <span v-if="scope.row.couponKind == 1">限品类京券,</span>
                  <span v-if="scope.row.couponKind == 2">店铺东券,</span>
                  <span v-if="scope.row.couponKind == 3">限商品东券,</span>
                  满{{ scope.row.quota }}减{{ scope.row.discount }}元
                </template>
              </el-table-column>
              <el-table-column :prop="venderType?'putkey':'couponIdOrPutKey'" label="优惠券id/key" width="120"> </el-table-column>

              <el-table-column prop="createTime" label="创建时间" width="180"> </el-table-column>
              <el-table-column label="领取时间" width="180">
                <template slot-scope="scope">
                  <span>起:{{ scope.row.takeBeginTime }}</span
                  ><br />
                  <span>止:{{ scope.row.takeEndTime }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="balanceNum" label="剩余数量" width="100"> </el-table-column>
              <el-table-column prop="numPerSending" label="单次发放数量" width="120"> </el-table-column>
              <el-table-column prop="status" label="奖品状态" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 1">未开始</span>
                  <span v-if="scope.row.status == 2">进行中</span>
                  <span v-if="scope.row.status == 3">已结束</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="70">
                <template slot-scope="scope">
                  <el-button
                    style="width: 50px;margin-left: -10px;color: #7B61FF;"
                    class="Notetake"
                    type="text"
                    @click="
                      chooseTab(scope.row);
                      dialogVisibleFrom = false;
                    "
                  >
                    选择
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              style="text-align: right; margin-top: 20px"
              @size-change="handleSizeChangeTwo"
              background
              @current-change="handleCurrentChangeTwo"
              :page-sizes="[10, 20, 30, 50, 100, 500]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNumTwo"
              :current-page="1"
            ></el-pagination>
            <div style="color: #7B61FF; padding: 20px 0 20px 40px">
              <!-- 注：此类型奖品暂时不支持自营店铺 -->
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :disabled="jdActual" label="京豆" name="second" v-if="isShowJingdou">
          <!-- <div class="topTis" v-if="tipShow">
            <i class="el-icon-warning" style="color: #7B61FF; marginright: 8px; font-size: 14px"></i>
            <div class="desc">
              <p>
                注意：为保证活动奖品正常发送，建议选择发豆规则与奖品发放规则一致的计划（比如活动期间最多邀请5人，则发豆规则建议选择“每日活动内发豆次数大于等于5次的京豆计划”）
              </p>
            </div>
          </div>
          <div class="topTis" v-else style="background:#fff"></div> -->

          <div style="height: 24px;"></div>
          <el-form ref="jingduoForm:" :model="jingduoForm" label-width="100px">
            <el-form-item label="选择京豆计划:">
              <el-select v-model="accountCode" placeholder="请选择" style="margin-right: 8px;" v-if="venderType">
                <el-option
                  v-for="item in accountCodeList"
                  :key="item.accountCode"
                  :label="item.accountCode"
                  :value="item.accountCode">
                </el-option>
              </el-select>
              <el-select v-model="jingduoForm.region" placeholder="请选择" @change="planChange" style="width: 215px">
                <el-option v-for="(item, index) in selectList" :key="index" :label="item.label" :value="item"></el-option>
              </el-select>
              <el-button type="text" @click="getJingdouList">刷新</el-button>
              <el-button style="width:auto" type="primary" @click="jumpJingduo">创建京豆计划</el-button>
              <div v-show="activeSendtimes">
                <span>京豆计划的发豆次数，最多</span>
                <span style="color:#7B61FF"> {{ activeSendtimes }} </span>次，
                <span>剩余京豆预算额<span style="color:#7B61FF">{{ jingduoForm.region.budgetRemain }}</span>个</span>
              </div>
            </el-form-item>
            <el-form-item label="单份奖励个数:">
              <el-input v-model="jingduoForm.count" @input.native="checkputn" style="width: 215px"></el-input>
              <span> 个京豆 （每人每次发送的京豆个数）</span>
            </el-form-item>
            <!-- <div style="color: red;margin-bottom: 20px;" v-if="jingduoForm.count>1000">因官方接口限制，单次发豆数量上限是1000，超过时会分多次发放，为确保发放成功，京豆计划发放次数必大于等于单份奖励个数/1000</div> -->
            <jd-tips>
              <p>注：</p>
              <p>因官方接口限制，如选择的京豆计划单次发放类型上限为1000时，超过会多次发放，为确保发放成功，京豆计划发放次数必须大于等于单份奖励个数/1000；</p>
              <p>如需发放超过1000建议选择单次发放类型上限为50000的京豆计划，如超过50000，也会多次发放；</p>
            </jd-tips>
            <el-form-item style="margin-left: -100px;">
              <el-button
                type="primary"
                style="width: 180px"
                @click="
                  () => {
                    this.getJingdouData();
                    this.setJingdouData();
                  }
                "
                :disabled="!jingduoForm.count"
                >选择京豆奖品</el-button
              >
            </el-form-item>
          </el-form>
          <div class="topTis" v-if="venderType&&!isOpenJinDou">
            <i class="el-icon-warning" style="color: #7B61FF; marginright: 8px; font-size: 14px"></i>
            <div class="desc" style="color: #666;">
              <p>
                自营店铺京豆使用流程：
              </p>
              <p class="topTis_line">
                1、开通白名单、账号授权
              </p>
              <p class="topTis_line">
                因京东平台对自营店铺充值有白名单限制，需要联系京东采销协助开通，请自营店铺在使用京豆前查看供应商充值操作流程。
              </p>
              <p class="topTis_line" style="color: #7B61FF;margin-bottom: 16px; cursor: pointer;" @click="toJdTeach">
                自营店铺京豆充值教程 >
              </p>
              <p class="topTis_line">
                2、绑定供应商简码、授权账号pin
              </p>
              <p class="topTis_line">
                如果供应商白名单，账号授权已经完成，请点击绑定供应商简码、授权账号pin；
              </p>
              <p class="topTis_line">
                绑定成功后需要重新进入活动页面，创建京豆计划。
              </p>
            </div>
          </div>
          <!-- 无链接 产品说隐藏该按钮 -->
          <!-- <el-button class="cancel" @click="toBindJd">点击绑定京豆授权账号</el-button> -->
        </el-tab-pane>
        <el-tab-pane :disabled="actual" label="实物" name="third" v-if="isShowThing">
          <div class="topTis">
            <i class="el-icon-warning" style="color: #7B61FF; marginright: 8px; font-size: 14px"></i>
            <div class="desc">
              <p>实物奖品需要用户中奖后在线填写邮寄地址方</p>
            </div>
          </div>
          <el-form ref="objectForm" :model="objectForm" :label-width="activityType=='36' ? '110px' : activityType=='8' ? '160px' : '74px'">

            <el-form-item label="奖品来源:">
              <el-radio-group v-model="objectForm.resource" @change="cleanImg">
                <el-radio label="2" v-if="isShowDirectlyFill">直接填写</el-radio>
                <el-radio label="1">从店铺中选择</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-show="objectForm.resource == 2">
              <el-upload
                ref="upload"
                action="#"
                list-type="picture-card"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :http-request="httpRequest"
                :file-list="fileList"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <!-- <el-dialog :visible.sync="dialogVisible" style="z-index:3050">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog> -->
              <span style="color: #7B61FF; font-size: 12px">建议尺寸：200*200像素，图片大小不能超过300K，类型：JPG、PNG</span>
            </el-form-item>
            <el-form-item v-if="objectForm.resource == 1">
              <div v-if="objectForm.logo && objectForm.resource == 1">
                <img :src="objectForm.logo" alt="" style="width: 150px; height: 150px" />
              </div>
              <el-button @click="dialogFormVisible = true" style="width: 110px; text-align: center;">选择店铺商品</el-button>
            </el-form-item>
            <el-form-item label="奖品名称:">
              <el-input v-model="objectForm.name" maxlength="12" show-word-limit style="width: 220px"></el-input>
            </el-form-item>
            <el-form-item label="奖品价值:">
              <el-input v-model="objectForm.discount" @blur="objectForm.discount = inputLimitZero($event)" @input.native="limitInput" style="width: 220px"></el-input>
              <span> 元/件</span>
            </el-form-item>
            <!-- 幸运抽奖显示 -->
            <div v-if="activityType=='8'">
              <el-form-item label="收货信息填写截至时间:">
                <div class="my_select_time1">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="deliveryInfo.addressFillEndTime"
                  type="datetime"
                  placeholder="收货信息填写截至时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 220px; font-size: 12px"
                  class="time1"
                  :picker-options="pickerOptionsValue"
                  :clearable="false"
                  @change="handleChangeTime"
                  :disabled="deliveryInfo.isFollowActivityEndTime==0"
                  :default-time="
                    this.$getDate(30)[0].substring(
                      11,
                      this.$getDate(30)[0].length
                    )
                  "
                >
                </el-date-picker>
                <i
                  v-if="deliveryInfo.isFollowActivityEndTime==1"
                  class="el-icon-circle-close date_icon1"
                  @click="clearTime()"
                ></i>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
              <span class="ml4">前填写(逾期奖品失效处理)</span>
              <div>
                <el-checkbox v-model="deliveryInfo.isFollowActivityEndTime" :true-label="0" :false-label="1" @change="handleSyncTime">跟随活动结束时间(修改活动结束时间时更新)</el-checkbox>
              </div>
              </el-form-item>
            </div>
            <!-- 下单冲榜显示 -->
            <el-form-item label="附加信息收集:" v-if="activityType=='36'" required>
              <el-radio-group v-model="attachInfo.shouldCollectExtraData">
                <el-radio :label="0">不设置附加信息</el-radio>
                <el-radio :label="1">设置附加信息</el-radio>
              </el-radio-group>
              <div>
                <setTopic
                  v-if="attachInfo.shouldCollectExtraData == 1"
                  @collectQuestion="collectQuestion"
                  :questions="attachInfo.questions"
                  :isShowAddBtn="false"
                  actionText="编辑"
                ></setTopic>
              </div>
            </el-form-item>
            <el-form-item style="margin-left: -74px;">
              <el-button type="primary" style="width: 180px" :disabled="!objectForm.name || !objectForm.discount || (objectForm.resource == 1 && !objectForm.skuId)" @click="changeJP()">选择实物奖品</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <!-- 实物(实物管理) -->
        <el-tab-pane label="实物(实物管理)" name="ten" v-if="isShowThingMag">
          <div style="margin-bottom: 15px">
            <jd-tips margin="20px 0">
              <p>
                奖品库存统一管理，支持批量对多个不同活动的实物中奖记录做发放，更便捷
              </p>
            </jd-tips>
          </div>
          <el-form ref="physicalForm" :model="redForm" label-width="130px">
            <el-form-item label="选择奖品:">
              <el-select v-model="physicalForm.region" placeholder="请选择" @change="handleChangePhysical">
                <el-option v-for="(item, index) in physicalList" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
              <el-button type="text" @click="resetPhysical">刷新</el-button>
              <el-button
                style="width: 180px;background: rgba(123,97,255,0.1);color:#7B61FF;border-radius: 4px;"
                type="primary"
                @click="createPhysical"
                >创建实物</el-button
              >
              <p v-if="physicalForm.inventoryType==1">不限库存</p>
              <p v-else>
                可用数量
                <span style="color: #fe4d45" v-if="physicalForm.budgetRemain>=0">{{ physicalForm.budgetRemain }}</span>
                <span v-else>--</span>
                件
              </p>
            </el-form-item>
            <el-form-item label="奖品价值:"> <el-input v-model="physicalForm.discount" @input.native="limitInput" @blur="physicalForm.discount = inputLimitZero($event)" style="width: 220px"></el-input> 元/件 </el-form-item>
            <el-form-item style="margin-left: -130px;">
              <el-button
                type="primary"
                style="width: 180px"
                :disabled="physicalForm.inventoryType==0&&!physicalForm.budgetRemain"
                @click="changePhysical"
                >选择实物</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="店铺积分" name="four" v-if="isShowShopPoints">
          <template v-if="!isPointsEnabled">
            <div style="height: 300px;">
              暂未开通此权限，请先开通后进行选择 <span @click="handlelink" class="pointer" style="color: #7B61FF;">去开通>></span>
            </div>
          </template>
          <template v-else>
            <div class="topTis">
              <i class="el-icon-warning" style="color: #7B61FF; marginright: 8px; font-size: 14px"></i>
              <div class="desc">
                <p>店铺积分：发放积分需要加入京东会员体系，并开通积分功能</p>
              </div>
            </div>
            <el-form ref="integralForm" :model="integralForm" label-width="103px">
              <el-form-item label="单份积分数量:">
                <el-input v-model.number="integralForm.discount" @input.native="checkputn" style="width: 220px"></el-input>
              </el-form-item>
              <el-form-item style="margin-left: -103px;">
                <el-button
                  type="primary"
                  style="width: 180px"
                  @click="
                    storePoint();
                    dialogVisibleFrom = false;
                  "
                  :disabled="!integralForm.discount"
                  >选择店铺积分奖品</el-button
                >
              </el-form-item>
            </el-form>
          </template>
        </el-tab-pane>
        <el-tab-pane label="京东E卡" name="fird" v-if="isShowEK">
          <div class="topTis">
            <i class="el-icon-warning" style="color: #7B61FF; marginright: 8px; font-size: 14px"></i>
            <div class="desc">
              <p>
                根据京东规则，新创建计划开始时间需要在当前时间5分钟后，如果您是刚刚创建计划，请稍后点击刷新
              </p>
            </div>
          </div>
          <el-form ref="ekForm" :model="ekForm" label-width="125px">
            <el-form-item label="选择京东E卡计划:">
              <el-select v-model="ekForm.region" placeholder="请选择" @change="change">
                <el-option v-for="(item, index) in eKselectList" :key="index" :label="item.label" :value="item.id"></el-option>
              </el-select>
              <el-button type="text" @click="acquireAssets">刷新</el-button>
              <el-button
                type="primary"
                style="width: 180px;background: rgba(123,97,255,0.1);color:#7B61FF;
                border-radius: 4px;"
                @click="jumpEkCz"
                >创建京东E卡官方充值</el-button
              >
              <el-button
                type="primary"
                style="width: 180px;background: rgba(123,97,255,0.1);color:#7B61FF;
                border-radius: 4px;"
                @click="jumpEk"
                >创建京东E卡发放计划</el-button
              >
              <p>
                剩余
                <span style="color: #7B61FF">{{ ekForm.budgetRemain }}</span>
                张
              </p>
            </el-form-item>
            <el-form-item label="单份奖品:">
              <el-input v-model="ekForm.num" style="width: 220px" :disabled="true"></el-input>
              <span> 张（京东E卡单份奖品每人每次只能奖励1张）</span>
            </el-form-item>
            <el-form-item style="margin-left: -125px;">
              <el-button
                type="primary"
                style="width: 180px"
                :disabled="!ekForm.num"
                @click="
                  jingDonData();
                  jingDonEka(5);
                "
                >选择京东E卡奖品</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="爱奇艺会员" name="six" v-if="isShowIQY">
          <div class="topTis">
            <i class="el-icon-warning" style="color: #7B61FF; marginright: 8px; font-size: 14px"></i>
            <div class="desc">
              <p>
                根据京东规则，新创建计划开始时间需要在当前时间5分钟后，如果您是刚刚创建计划，请稍后点击刷新
              </p>
            </div>
          </div>
          <el-form ref="aqyForm" :model="aqyForm" label-width="144px">
            <el-form-item label="选择爱奇艺会员计划:">
              <el-select v-model="aqyForm.region" placeholder="请选择" @change="change">
                <el-option v-for="(item, index) in eKselectList" :key="index" :label="item.label" :value="item.id"></el-option>
              </el-select>
              <el-button type="text" @click="acquireAssets">刷新</el-button>
              <el-button
                type="primary"
                style="width: 180px;background: rgba(123,97,255,0.1);color:#7B61FF;
border-radius: 4px;"
                @click="jumpaqyCz"
                >创建爱奇艺官方充值</el-button
              >
              <el-button
                type="primary"
                style="width: 180px;background: rgba(123,97,255,0.1);color:#7B61FF;
border-radius: 4px;"
                @click="jumpaqy"
                >创建爱奇艺发放计划</el-button
              >
              <p>
                剩余
                <span style="color: #7B61FF">{{ aqyForm.budgetRemain }}</span>
                张
              </p>
            </el-form-item>
            <el-form-item label="单份奖品:">
              <el-input v-model="aqyForm.num" style="width: 220px" :disabled="true"></el-input>
              <span> 张（爱奇艺会员单份奖品每人每次只能奖励1张）</span>
            </el-form-item>
            <el-form-item style="margin-left: -144px;">
              <el-button
                type="primary"
                style="width: 180px"
                :disabled="!aqyForm.num"
                @click="
                  jingDonData();
                  jingDonEka(6);
                "
                >选择爱奇艺会员奖品</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="京东PLUS会员" name="sev" v-if="isShowPLUS">
          <div class="topTis">
            <i class="el-icon-warning" style="color: #7B61FF; marginright: 8px; font-size: 14px"></i>
            <div class="desc">
              <p>
                根据京东规则，新创建计划开始时间需要在当前时间5分钟后，如果您是刚刚创建计划，请稍后点击刷新
              </p>
            </div>
          </div>
          <el-form ref="plusForm" :model="plusForm" label-width="165px">
            <el-form-item label="选择京东PLUS会员计划:">
              <el-select v-model="plusForm.region" placeholder="请选择" @change="change">
                <el-option v-for="(item, index) in eKselectList" :key="index" :label="item.label" :value="item.id"></el-option>
              </el-select>
              <el-button type="text" @click="acquireAssets">刷新</el-button>
              <el-button
                type="primary"
                style="width: 180px;
background: rgba(123,97,255,0.1);color:#7B61FF;
border-radius: 4px;"
                @click="jumpPlusCz"
                >创建PLUS会员充值</el-button
              >
              <el-button
                type="primary"
                style="width: 180px;background: rgba(123,97,255,0.1);color:#7B61FF;
border-radius: 4px;"
                @click="jumpPlus"
                >创建PLUS会员发放</el-button
              >
              <p>
                剩余
                <span style="color: #7B61FF">{{ plusForm.budgetRemain }}</span>
                张
              </p>
            </el-form-item>
            <el-form-item label="单份奖品:">
              <el-input v-model="plusForm.num" style="width: 220px" :disabled="true"></el-input>
              <span> 张，（京东PLUS会员单份奖品每人每次只能奖励1张）</span>
            </el-form-item>
            <el-form-item style="margin-left: -165px;">
              <el-button
                type="primary"
                style="width: 180px"
                :disabled="!plusForm.num"
                @click="
                  jingDonData();
                  jingDonEka(7);
                "
                >选择京东PLUS奖品</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="现金红包" name="eig" v-if="isShowHongBao">
          <div class="topTis">
            <i class="el-icon-warning" style="color: #7B61FF; marginright: 8px; font-size: 14px"></i>
            <div class="desc">
              <p>
                根据京东规则，红包计划创建后10分钟才能生效，为避免等待时间，请提前创建活动！
              </p>
              <p>默认红包计划最短不少于3天，最长不超过30天，详见红包权益；</p>
            </div>
          </div>
          <el-form ref="ekForm" :model="redForm" label-width="130px">
            <el-form-item label="选择现金红包计划:">
              <!-- <el-select v-model="redForm.region" placeholder="请选择">
                <el-option label="计划一" value="shanghai"></el-option>
                <el-option label="计划二" value="beijing"></el-option>
                <el-option label="计划三" value="beijing"></el-option>
              </el-select> -->
              <el-select v-model="redForm.region" placeholder="请选择" @change="change1">
                <el-option v-for="(item, index) in redSelectList" :key="index" :label="item.label" :value="item.id"></el-option>
              </el-select>
              <el-button type="text" @click="redBag">刷新</el-button>
              <el-button
                type="primary"
                style="width: 180px;background: rgba(123,97,255,0.1);color:#7B61FF;
border-radius: 4px;"
                @click="jumpRedCz"
                >创建现金红包充值</el-button
              >
              <el-button
                type="primary"
                style="width: 180px;background: rgba(123,97,255,0.1);color:#7B61FF;
border-radius: 4px;"
                @click="jumpRed"
                >创建现金红包发放</el-button
              >
              <p>
                剩余
                <span style="color: #7B61FF">{{ redForm.budgetRemain }}</span>
                份
              </p>
            </el-form-item>
            <el-form-item label="单份奖品:"> <el-input v-model="redForm.num" style="width: 220px" :disabled="true"></el-input> 元 </el-form-item>
            <el-form-item style="margin-left: -130px;">
              <el-button
                type="primary"
                style="width: 180px"
                :disabled="!redForm.num"
                @click="
                  redData();
                  jingDonEka(8);
                "
                >选择红包奖品</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <!-- v1.18新增礼品卡 -->
        <el-tab-pane label="礼品卡" name="nine" v-if="isShowGiftCard">
          <gift-card-prize v-if="isShowGift" :giftCardList="giftCardList" :giftData="giftCardForm" @refreshGiftCard="refreshGiftCard" @handleGetGiftCard="handleGetGiftCard"></gift-card-prize>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <!-- 选择商品弹窗 -->
    <el-dialog title="选择商品" :visible.sync="dialogFormVisible" width="820px">
      <input-form style="margin: 20px 0" :inputData="commodityList" @toParentVal="searchContent" :immediately="true"></input-form>
      <el-table
        :data="tableShopData"
        stripe
        style="width: 90%; margin: 0 auto"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <el-table-column width="100">
          <template slot-scope="scope">
            <img :src="scope.row.logo" class="avar" alt="商品图片" style="height: 60px; width: 60px" />
          </template>
        </el-table-column>
        <el-table-column prop="skuName" label="商品名称" width="300">
          <template slot-scope="scope">
            <a :href="scope.row.itemUrl" target="_blank"
              >{{ scope.row.skuName }}<br />
              ¥{{ scope.row.jdPrice }}</a
            >
            <!-- <span>{{ scope.row.skuName }}</span
            ><br />
            <span>¥{{ scope.row.jdPrice }}</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="skuId" label="SKU ID" width="200"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="chooseShop(scope.row)" v-loading="sureLoading" style="width: 50px">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin: 40px 80px 0 0; text-align: right"
        background
        @size-change="handleSizeChangeThr"
        @current-change="handleCurrentChangeThr"
        :current-page="formShopList.current"
        :page-sizes="[5, 10, 30, 50, 100]"
        :page-size="formShopList.size"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="totalListThr"
      ></el-pagination>
    </el-dialog>
    <add-coupon :isSuperFission="true" :isShow="addCouponIsShow" @close="addCouponIsShow = false" @funcMes="addStatus"></add-coupon>
    <add-coupon2 :isShow="addCouponIsShow2" @close="addCouponIsShow2 = false" @funcMes="addStatus2"></add-coupon2>
  </div>
</template>

<script>
import jdTips from "@/components/common/jdTips.vue";
import inputForm from "../../components/inputForm";
import SelectGoods from "../../components/selectGoodsMonitor";
import { mapState } from "vuex";
import { couponList, jingdouList, allAccountList, redPacketList, judgingActivation,isauth } from "@/api/integralCenter/prizeCenter.js";
import { querySellerCouponWriteList, querySellerCouponExternalList, createSellerCouponWrite } from "@/api/integralCenter/couponWriteController";
import { getTaobaoItemListSku, getSellercats } from "@/api/analysis/ware-controller.js";
import { uploadpic } from "@/api/paradiseAndTaskCommonController.js";
import { getSupplierAccountList } from "@/api/integralCenter/prizeCenter.js";
import addCoupon from "./add_coupon1.vue";
import addCoupon2 from "./add_coupon2.vue";
import giftCardPrize from "./components/giftCard/giftCardPrize.vue";
import {getGoodsPage} from "@/api/integralCenter/physical.js";
import {getGiftCardPage} from "@/api/integralCenter/prizeCenter.js";
import setTopic from "./components/setTopic/index.vue";
const actionType = ["", "jingdouPut"];
import { checkProduct } from "@/api/integralCenter/prizeCenter.js";
export default {
  name: "selectProduct",
  components: {
    inputForm,
    SelectGoods,
    addCoupon,
    addCoupon2,
    giftCardPrize,
    jdTips,
    setTopic
  },
  props: {
    //隐藏优惠券
    isShowFirst: {
      type: Boolean,
      default: false,
    },
    // 隐藏内部券
    Sans: {
      type: Boolean,
      default: false,
    },
    // 隐藏外部券
    outsideShow: {
      type: Boolean,
      default: false,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    // 爱奇艺、E卡、红包回显
    actId: null,
    tipShow: {
      type: Boolean,
      default: false,
    },
    putPrize: {
      type: Object,
    },
    // 回显的数据
    echoDate: {
      type: Object,
    },
    //typeDefault可不传 默认京券 免费领取 不公开 （店铺礼包、每日抢、评价有礼、裂变神券、天降红包雨幸运抽奖 ，互动中心-会员权益-新人优惠券、会员券）
    typeDefault: {
      type: Object,
      default() {
        return {
          grantType: 3, // 发放类型  传对应的id值
          display: 1, // 是否公开  传对应的id值
          type: 0, // 不禁用  传对应的id值
          noDisabled: [3], // 不禁用  传对应的id值  可不传（全部可选）
        };
      },
    },
    // num != 2 JingdouCount中的prizeCount必传 计算填的京豆总数是否大于京豆总数
    JingdouCount: {
      type: Object,
      default() {
        return {
          prizeCount: 0,
        };
      },
    },
    // 奖品类型 是否有梯度奖品  1否 2是
    num: {
      default: 2,
    },
    jdArr:{
      type: Array,
      default(){
        return []
      }
    },
    // 新增活动类型判断是否加设置收集附加信息和收货地址
    activityType: {
      type: String,
      default: "",
    },
    // 收货时间默认要等与活动结束时间
    endTime: {
      type: String,
      default: '',
    },
    isShowJingdou: {
      type: Boolean,
      default: true,
    },
    isShowThing: {
      type: Boolean,
      default: true,
    },
    isShowThingMag: {
      type: Boolean,
      default: true,
    },
    isShowShopPoints: {
      type: Boolean,
      default: true,
    },
    isShowEK: {
      type: Boolean,
      default: true,
    },
    isShowIQY: {
      type: Boolean,
      default: true,
    },
    isShowPLUS: {
      type: Boolean,
      default: true,
    },
    isShowHongBao: {
      type: Boolean,
      default: true,
    },
    isShowGiftCard: {
      type: Boolean,
      default: true,
    },
    defaultSelect: {
      type: String,
      default: "",
    },
    isShowDirectlyFill: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    ...mapState(["venderType"]),
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    }
  },
  watch: {
    async dialogVisibleFrom(news) {
      console.log("this.echoDate===>",this.echoDate);
      // 回显
      if (news) {
        if (this.echoDate.prizeType == 9 || this.echoDate.prizeType == 1 || !this.echoDate.prizeType) {
          if (!this.isShowFirst) {
            this.handleClick({ name: "first" });
            this.activeName = "first";
          } else {
            this.handleClick({ name: "second" });
            this.activeName = "second";
          }
          // 暂时是隐藏某些项时外传进来的默认值
          if (this.defaultSelect) {
            this.handleClick({ name: this.defaultSelect });
            this.activeName = this.defaultSelect;
          }
        }
        if (this.echoDate.prizeType == 2) {
          this.handleClick({ name: "second" });
          this.activeName = "second";
          this.jingduoForm.region = {
            value: this.echoDate.assetsId + "",
            budgetRemain: this.echoDate.budgetRemain,
          };
          this.jingduoForm.count = this.echoDate.price;
        }
        if (this.echoDate.prizeType == 3) {
          if(this.echoDate.isGoodManage) {
            await this.handleClick({ name: "ten" });
            this.activeName = "ten";
            this.physicalForm.isGoodManage = this.echoDate.isGoodManage
            this.physicalForm.region = this.echoDate.assetsId + "";
            this.physicalForm.name = this.echoDate.name
            this.physicalForm.discount = this.echoDate.price;
            this.physicalForm.logo = this.echoDate.logo;
            this.physicalForm.giftType = "1";
            this.physicalForm.singleAmount = 1;
            this.physicalList.some((item) => {
              if (item.id == this.echoDate.assetsId) {
                this.physicalForm.budgetRemain = item.budgetRemain;
                this.physicalForm.inventoryType = item.inventoryType;
              }
            });
          } else {
            console.log('this.echoDate',this.echoDate)
            this.handleClick({ name: "third" });
            this.activeName = "third";
            this.objectForm.discount = this.echoDate.price;
            this.objectForm.name = this.echoDate.title;
            this.objectForm.logo = this.echoDate.logo;
            this.objectForm.skuId = this.echoDate.assetsId;
            this.objectForm.resource = this.echoDate.giftType ? this.echoDate.giftType + "" : "1";
            this.objectForm.skuId = this.echoDate.assetsId;
            this.objectForm.categoryId = this.echoDate.categoryId;
            this.fileList = [
              {
                url: this.echoDate.logo,
                name: this.echoDate.title,
              },
            ];
            // 幸运抽奖新增收货时间
            if(this.activityType=='8') {
              // 复制一份用来同步未勾选活动结束时间赋值
              this.deliveryTime = this.echoDate.addressFillEndTime ? this.echoDate.addressFillEndTime : this.endTime;
              this.deliveryInfo.isFollowActivityEndTime = this.echoDate.isFollowActivityEndTime>=0 ? this.echoDate.isFollowActivityEndTime : 1;
              if(this.deliveryInfo.isFollowActivityEndTime==1) {
                this.deliveryInfo.addressFillEndTime = this.echoDate.addressFillEndTime ? this.echoDate.addressFillEndTime : this.endTime;
              } else {
                this.deliveryInfo.addressFillEndTime = ""
              }
            }
            if(this.activityType=='36') {
              // 附加信息回显
              this.attachInfo = {
                shouldCollectExtraData: this.echoDate.shouldCollectExtraData ? this.echoDate.shouldCollectExtraData : 0,
                questions: this.echoDate.extraQuestion&&this.echoDate.extraQuestion.title ? [this.echoDate.extraQuestion] : [{type: 1,isMust: 1}],
              }
            }
            if (this.objectForm.resource == 2) {
              this.$nextTick(() => {
                this.$refs.upload.$children[1].$el.style.display = "none";
              });
            }
          }
        }else{
          this.objectForm.name = '';
          this.objectForm.logo = '';
          this.fileList = [];
        }

        if (this.echoDate.prizeType == 4) {
          this.handleClick({ name: "four" });
          this.activeName = "four";
          this.integralForm.discount = this.echoDate.singleAmount;
        }
        if (this.echoDate.prizeType == 5) {
          await this.handleClick({ name: "fird" });
          this.activeName = "fird";
          this.ekForm.region = this.echoDate.assetsId + "";
          this.ekForm.num = 1;
          let that = this;

          that.eKselectList.forEach((item) => {
            if (item.id == that.echoDate.assetsId) {
              console.log(item,"===========>");
              that.ekForm.quantityBalance = item.quantityBalance;
              that.ekForm.budgetRemain = item.budgetRemain;
            }
          });
        }
        if (this.echoDate.prizeType == 6) {
          await this.handleClick({ name: "six" });
          this.activeName = "six";
          this.aqyForm.region = this.echoDate.assetsId + "";

          this.aqyForm.num = 1;
          let that = this;

          that.eKselectList.forEach((item) => {
            if (item.id == that.echoDate.assetsId) {
              that.aqyForm.quantityBalance = item.quantityBalance;
              that.aqyForm.budgetRemain = item.budgetRemain;
            }
          });
        }
        if (this.echoDate.prizeType == 7) {
          await this.handleClick({ name: "sev" });
          this.activeName = "sev";
          this.plusForm.region = this.echoDate.assetsId + "";

          this.plusForm.num = 1;
          let that = this;

          that.eKselectList.forEach((item) => {
            if (item.id == that.echoDate.assetsId) {
              that.plusForm.quantityBalance = item.quantityBalance;
              that.plusForm.budgetRemain = item.budgetRemain;
            }
          });
        }
        if (this.echoDate.prizeType == 8) {
          await this.handleClick({ name: "eig" });
          this.activeName = "eig";
          this.redForm.region = this.echoDate.assetsId + "";

          // this.redForm.num = 1;
          let that = this;
          that.redSelectList.forEach((item) => {
            if (item.id == that.echoDate.assetsId) {
              that.redForm.quantityBalance = item.quantityTotal ? item.quantityTotal - item.quantityActual : "";
              that.redForm.num = item.quantityAmount ? item.quantityAmount / item.quantityTotal : "";
              that.redForm.budgetRemain = item.budgetRemain
            }
          });
        }
        if (this.echoDate.prizeType == 10) {
          await this.handleClick({ name: "nine" });
          this.activeName = "nine";
          this.giftCardForm.region = this.echoDate.assetsId + "";
          this.giftCardForm.num = this.echoDate.price;
          this.giftCardForm.name = this.echoDate.title;
          this.giftCardForm.logo = this.echoDate.logo;
          this.giftCardList.forEach((item) => {
            if (item.id == this.echoDate.assetsId) {
              this.giftCardForm.budgetRemain = item.actualBalance
            }
          });
        }
      }
      // 禁止梯度奖品选择第二个京豆奖品
      // var jinDou,jinDou1
      // if(this.$parent.itemArr){
      //   jinDou = this.$parent.itemArr.some((i) => {
      //     return i.prizeType == 2;
      //   });
      // }
      // if(this.$parent.tableData){
      //   jinDou1 = this.$parent.tableData.some((i) => {
      //     return i.prizeType == 2;
      //   });
      // }
      // var tj2 = this.$parent.clickActual1;
      // 修改京东奖品时不置灰
      var tj3 = this.$parent.echoDate.prizeType == 2
      
      // console.log('itemArr',jinDou,'tableData',jinDou1,'ech',this.$parent.echoDate,tj3);
      // this.jdActual = jinDou&&!tj3 ? true : false;

      if(this.isShowFirst && this.jdActual){
        this.activeName = "third"
      }


      this.$nextTick(() => {
        if(this.$refs.inputForms) {
          this.$refs.inputForms.formSearch();
        }
      });
    },
    venderType:{
      handler(newVal) {
        if(newVal) {
          this.getSupplierList()
        }
      },
      immediate:true
    },
    venderId: {
      handler(newVal) {
        if(newVal&&this.venderType) {
          this.formAccount.accountCode = newVal
          this.formAccount.accountType = "1"
        } 
        this.getJingdouList()
      },
      immediate: true
    },
    accountCode:{
      handler(newVal) {
        if(newVal) {
          if(newVal=="商家账户") {
            this.formAccount.accountCode = this.venderId
            this.formAccount.accountType = "1"
          }else {
            this.formAccount.accountCode = newVal
            this.formAccount.accountType = "2"
          }
          this.jingduoForm.region = ""
          this.getJingdouList()
        }
      }
    }
  },
  provide() {
    return {
      isShowMatrix: false,
      isShowMoreSelect: false,
      isShowPictureSingle: false,
      isShowPicUpload: false,
    };
  },
  data() {
    return {
      sureLoading: false,
      formData: {
        current: 1,
        size: 9999999
      },
      formAccount: {
        accountCode: "",
        accountType: ""
      },
      accountCode: "商家账户",
      accountCodeList:[],
      isOpenJinDou: false,
      // echoDate: {},
      addCouponIsShow: false,
      inputDataTwo: [
        {
          name: "优惠券名称:",
          val: "name",
          placeholder: "请输入",
        },
        {
          name: "优惠券id/key:",
          val: "couponIdOrPutKey",
          placeholder: "请输入",
        },
        {
          name: "奖品状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
        {
          name: "优惠券使用范围:",
          val: "couponKind",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "全店", id: 2 },
            { label: "商品", id: 3 },
            { label: "全品类", id: 0 },
            { label: "限品类", id: 1 },
          ],
        },
        {
          name: "创建时间:",
          myDate: true,
          val: ["beginTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
      ],
      awardSettingsLsit: [
        {
          prizeType: 1,
          price: null,
          title: "",
          singleAmount: null,
          totalAmount: "",
          inviteNum: null,
          takeEndTime: null,
          takeBeginTime: null,
          isMain: 1,
          quota: null,
        },
      ],
      FissionVoucherList: [],
      addCouponIsShow2: false,

      isPointsEnabled: false,
      // isShowFirst: true, //邀请开卡活动隐藏优惠券一栏
      actual: false,
      jdActual: false,
      fileList: [],
      form: {
        imageUrl: "",
      },
      dialogFormVisible: false,
      // returnSelectGoods: [],
      returnSelectGoodsAppoint: [], //选择商品回显
      postForm: {
        orderStartTime: "",
        testSelect: 0,
      },
      goodsStateLength: 0,
      goodsStateLength1: 0,
      selectList: [],
      eKselectList: [],
      redSelectList: [],
      tableLoading: true,
      activeName: "first",
      listName: this.Sans ? "second" : "first",
      // 互动任务-店铺礼包、每日抢、评价有礼、裂变神券、天降红包雨】、【互动乐园-幸运抽奖 默认京券 免费领取 不公开
      inputData: [
        {
          name: "类型:",
          val: "type",
          placeholder: "请选择",
          selectArr: [
            { label: "京券", id: 0, defaultValue: 0 },
            { label: "东券", id: 1 },
          ],
        },
        {
          name: "发放类型:",
          val: "grantType",
          placeholder: "请选择",
          selectArr: [
            { label: "促销绑定", id: 1, defaultValue: 3, disabled: true },
            { label: "推送", id: 2, disabled: true },
            { label: "免费领取", id: 3, disabled: false },
            { label: "京豆换券", id: 4, disabled: true },
            { label: "互动平台", id: 5, disabled: true },
          ],
        },
        {
          name: "是否公开:",
          val: "display",
          placeholder: "请输入",
          selectArr: [
            { label: "不公开", id: 1, defaultValue: 1 },
            { label: "公开", id: 3 },
          ],
        },
      ],
      internalTable: [],
      externalTable: [],
      totalNum: 0,
      totalNumTwo: 0,
      jingduoForm: {
        count: null,
        region:{
          budgetRemain: ""
        }
      },
      objectForm: {
        logo: "",
        resource: "1",
        name: "",
        discount: null,
      },
      integralForm: {
        discount: null,
      },
      ekForm: {
        quantityBalance: 0,
        budgetRemain:0,
      },
      aqyForm: {
        quantityBalance: 0,
        budgetRemain:0,
      },
      plusForm: {
        quantityBalance: 0,
        budgetRemain:0,
      },
      redForm: {
        num: "",
        quantityBalance: 0,
        budgetRemain:0,
        region: ""
      },
      physicalList: [],
      isShowGift: false,
      giftCardForm: {
        region: "",
        logo: "",
        num: "1",
        budgetRemain: "",
        name: "",
        singleAmount: 1
      },
      physicalForm: {
        region: "",
        logo: "",
        name: "",
        discount: "",
        budgetRemain: "",
        giftType: "1",
        singleAmount: 1,
        isGoodManage: 1,
        inventoryType: 0
      },
      dialogImageUrl: "",
      dialogVisible: false,
      dialogVisibleFrom: this.isShow,
      formList: {
        current: 1,
        size: 10,
        isTake: 1,
      },
      formListTwo: {
        current: 1,
        size: 10,
        isTake: 1,
        issueType: 0,
      },
      formLitJD: {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 4,
      },
      formLitZC: {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 4,
      },
      formLitRed: {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 4,
      },
      jingdouData: {},
      tabActive: 3,
      selectZCList: {},
      zcData: {},
      commodityList: [
        {
          name: "商品类目:",
          placeholder: "请选择",
          val: "categoryId",
          cascaderArr: [],
          multiple: true,
          width: 240,
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID",
          isNumber: true,
          width: 240,
        },
        {
          name: "商品名称:",
          val: "skuName",
          placeholder: "请输入商品名称",
          width: 240,
        },
        {
          name: "商品状态:",
          val: "skuStatus",
          default: 1,
          selectArr: [
            { label: "全部", id: null },
            { label: "上架", id: 1 },
            { label: "下架", id: 2 },
          ],
          width: 136,
        },
      ],
      tableShopData: [],
      totalListThr: 0,
      formShopList: { current: 1, size: 5, skuStatus: 1 },
      nowTime: "",
      activeSendtimes: "",
      planList: {
        jingdou: {},
      },
      // 收货时间范围限制
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.endTime).valueOf());
        },
      },
      deliveryInfo: {
        addressFillEndTime: "",
        isFollowActivityEndTime: 1,
      },
      deliveryTime: "",
      // 附加信息
      attachInfo: {
        shouldCollectExtraData: 0,
        questions: [{type: 1,isMust: '1'}]
      }
    };
  },
  mounted() {
    this.getIsauth()
    // 类型默认
    this.inputData[0].selectArr[0].defaultValue = this.typeDefault.type;
    // 是否公开
    this.inputData[2].selectArr[0].defaultValue = this.typeDefault.display;
    // 发放类型 禁用
    this.inputData[1].selectArr[0].defaultValue = this.typeDefault.grantType;
    if (this.typeDefault && this.typeDefault.noDisabled) {
      this.inputData[1].selectArr.forEach((item) => {
        this.typeDefault.noDisabled.forEach((i) => {
          if (item.id === i) {
            item.disabled = false;
          } else {
            item.disabled = true;
          }
        });
      });
    }
    this.formList.type = this.typeDefault.type;
    this.formList.display = this.typeDefault.display;
    this.formList.grantType = this.typeDefault.grantType;
    judgingActivation().then((res) => {
      this.isPointsEnabled = res.data;
    });
    // this.quireList();
    this.getShopList();
    this.getSeller();
    if (this.Sans) {
      // this.querySellerCouponExternal();
    }
    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     this.$refs.inputForms.formSearch();
    //   }, 10);
    // });
    // 邀请开卡v3.4
    console.log(this.$parent);
    if (this.$parent.localStepNum == 4 || this.$parent.localStepNum == 5) {
      // this.setDefalut();

      var tj1 = this.$parent.tableData.some((i) => {
        return i.prizeType == 3;
      });
      
      // 点击到已选实物奖品的条件，不置灰实物tab
      var tj2 = this.$parent.clickActual;
      // this.actual = tj1 && tj2 ? true : false;

      // this.isShowFirst = true;
      // this.activeName = "second";
    }
    // var jinDou = this.$parent.tableData.some((i) => {
    //   return i.prizeType == 2;
    // });
    // this.jdActual = jinDou ? true : false;
    // console.log(jinDou);
  },
  methods: {
    // 收集题目
    collectQuestion(question) {
      this.attachInfo.questions = question;
    },
    clearTime() {
      this.deliveryInfo.addressFillEndTime = "";
      this.deliveryTime = ""
    },
    // 同步活动结束时间
    handleSyncTime(val) {
      if(val==0) {
        this.deliveryInfo.addressFillEndTime = "";
      } else {
        this.deliveryInfo.addressFillEndTime = this.deliveryTime;
      }
    },
    handleChangeTime(val) {
      this.deliveryTime = val;
    },
    refreshGiftCard() {
      this.getGiftCardList()
    },
    // v1.18新增 查询实物（实物管理）
    async getPhysical() {
      try {
        let arr = []
        if(this.$parent.activityData){
          if(this.$parent.activityData.id == 36){ // 下单冲榜特殊处理
            this.$parent.editableTabs.forEach(tabs=>{
              tabs.content.forEach(item=>{
                if(item.prizeType == 3&&item.isGoodManage==1){
                  if(item.assetsId != this.$parent.echoDate.assetsId){
                    arr.push(item.assetsId)
                  }
                }
              })
            })
          }else if(this.$parent.activityData.id !=4 && this.$parent.activityData.id != 5){
            this.$parent.itemArr.forEach(item=>{
              if(item.prizeType == 3&&item.isGoodManage==1){
                if(item.assetsId != this.$parent.echoDate.assetsId){
                  arr.push(item.assetsId)
                }
              }
            })
            if(this.$parent.awardSettingsLsit){
              console.log(this.$parent.awardSettingsLsit,'this.$parent.awardSettingsLsit===>');
              this.$parent.awardSettingsLsit.forEach(item=>{
                if(item.prizeType == 3&&item.isGoodManage==1){
                  if(item.assetsId != this.$parent.echoDate.assetsId){
                    arr.push(item.assetsId)
                  }
                }
              })
            }
          }else{
            // 邀请关注和邀请开卡有三种奖品类型，分开处理
            // 奖品类型 0统一(awardSettingsLsit) 1梯度(itemArr) 2任务(taskTableData)
            if(this.$parent.ruleForm.isCumulativePrize==0){
              if(this.$parent.awardSettingsLsit){
                this.$parent.awardSettingsLsit.forEach(item=>{
                  if(item.prizeType == 3&&item.isGoodManage==1){
                    if(item.assetsId != this.$parent.echoDate.assetsId){
                      arr.push(item.assetsId)
                    }
                  }
                })
              }
            }else if(this.$parent.ruleForm.isCumulativePrize==1){
              this.$parent.itemArr.forEach(item=>{
                if(item.prizeType == 3&&item.isGoodManage==1){
                  if(item.assetsId != this.$parent.echoDate.assetsId){
                    arr.push(item.assetsId)
                  }
                }
              })
            }else if(this.$parent.ruleForm.isCumulativePrize==2){
              this.$parent.taskTableData.forEach(item=>{
                if(item.prizeType == 3&&item.isGoodManage==1){
                  if(item.assetsId != this.$parent.echoDate.assetsId){
                    arr.push(item.assetsId)
                  }
                }
              })
            }
          }
        }
        let params = {
          ...this.formData,
          activityId: this.actId ? this.actId.id : "",
          idList: arr.join(",")
        }
        this.tableLoading = true;
        const res = await getGoodsPage(params);
        if (res.code == 1) {
          this.tableLoading = false;
         let selectArr = res.data.records.map((item)=>{
          return {
              label: item.goodsName,
              ...item
            };
         })
          this.physicalList = selectArr;
        }
      } catch (error) {
        this.tableLoading = false;
      }
    },
    // v1.18新增礼品卡
    async getGiftCardList() {
      try {
        let arr = []
        if(this.$parent.activityData){
          if(this.$parent.activityData.id == 36){ // 下单冲榜特殊处理
            this.$parent.editableTabs.forEach(tabs=>{
              tabs.content.forEach(item=>{
                if(item.prizeType == 10){
                  if(item.assetsId != this.$parent.echoDate.assetsId){
                    arr.push(item.assetsId)
                  }
                }
              })
            })
          }else if(this.$parent.activityData.id !=4 && this.$parent.activityData.id != 5){
            this.$parent.itemArr.forEach(item=>{
              if(item.prizeType == 10){
                if(item.assetsId != this.$parent.echoDate.assetsId){
                  arr.push(item.assetsId)
                }
              }
            })
            if(this.$parent.awardSettingsLsit){
              console.log(this.$parent.awardSettingsLsit,'this.$parent.awardSettingsLsit===>');
              this.$parent.awardSettingsLsit.forEach(item=>{
                if(item.prizeType == 10){
                  if(item.assetsId != this.$parent.echoDate.assetsId){
                    arr.push(item.assetsId)
                  }
                }
              })
            }
          }else{
            // 邀请关注和邀请开卡有三种奖品类型，分开处理
            // 奖品类型 0统一(awardSettingsLsit) 1梯度(itemArr) 2任务(taskTableData)
            if(this.$parent.ruleForm.isCumulativePrize==0){
              if(this.$parent.awardSettingsLsit){
                this.$parent.awardSettingsLsit.forEach(item=>{
                  if(item.prizeType == 10){
                    if(item.assetsId != this.$parent.echoDate.assetsId){
                      arr.push(item.assetsId)
                    }
                  }
                })
              }
            }else if(this.$parent.ruleForm.isCumulativePrize==1){
              this.$parent.itemArr.forEach(item=>{
                if(item.prizeType == 10){
                  if(item.assetsId != this.$parent.echoDate.assetsId){
                    arr.push(item.assetsId)
                  }
                }
              })
            }else if(this.$parent.ruleForm.isCumulativePrize==2){
              this.$parent.taskTableData.forEach(item=>{
                if(item.prizeType == 10){
                  if(item.assetsId != this.$parent.echoDate.assetsId){
                    arr.push(item.assetsId)
                  }
                }
              })
            }
          }
        }
        let params = {
          current: 1,
          size: 10000,
          status: 2,
          isFilterUsed: true,
          activityId: this.actId ? this.actId.id : "",
          idStr: arr.join(",")
        }
        const res = await getGiftCardPage(params);
        if (res.code == 1) {
          let selectArr = res.data.records.map((item) => {
            return {
              ...item,
              label: item.planName
            };
          });
        // 过滤出当前活动未使用的计划
        this.giftCardList = selectArr;
        }
      } catch (error) {
      }
    },
    async getSupplierList() {
      try {
        const res = await getSupplierAccountList()
        if(res.code==1) {
          let list = res.data
          this.accountCodeList = list.map((item)=>{
            let obj = {}
            obj['accountCode'] = item
            return obj
          })
          this.accountCodeList.unshift({
            accountCode: "商家账户",
          })
        }else {
          this.accountCodeList.unshift({
            accountCode: "商家账户",
          })
        }
      } catch (error) {
        
      }
    },
    // 查询是否开通京豆计划
    async getIsauth() {
      const res = await isauth()
      if(res.code==1) {
        this.isOpenJinDou = res.data
      } else {
        this.isOpenJinDou = false
      }
    },
    handleSizeChange2(val) {
      this.formListTwo.size = val;
      this.quireList();
    },
    handleCurrentChange2(val) {
      this.formListTwo.current = val;
      this.quireList();
    },
    addStatus(val) {
      let obj = val;
      createSellerCouponWrite(obj)
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success(res.message);
            this.$refs.inputForms.formSearch();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {});
      // this.awardSettingsLsit[0].assetsId = data
      return;
    },
    addStatus2() {
      // this.$refs.inputForm.formSearch();
      this.$refs.inputForms.formSearch();
    },
    searchContentTwo(val) {
      this.formListTwo = {
        isTake: 1,
        current: "1",
        ...val,
      };
      this.querySellerCouponExternal();
    },
    handleAddCoupon() {
      this.addCouponIsShow = true;
      // this.echoDate = {}
    },
    handleAddCoupon2() {
      this.addCouponIsShow2 = true;
      // this.echoDate2 = {}
    },
    // 京豆充值教程
    toJdTeach() {
      window.open("https://www.yuque.com/yunduanxincrm/flgan6/wm6y952zt56lgu6b");
    },

    handlelink() {
      window.open("https://member.shop.jd.com/index/newmemberlevel");
    },
    planChange(val) {
      this.activeSendtimes = val.sendTimes;
    },
    setDefalut() {
      if (this.putPrize.prizeType) {
      }
    },
    dialogClose() {
      this.$emit("close");
    },

    cleanImg() {
      this.objectForm.logo = "";
      this.objectForm.name = "";
      this.objectForm.discount = null;
      if(this.fileList.length < 1){
        this.$refs.upload.$children[1].$el.style.display = "inline-block";
      } 
      
    },
    dateFormat() {
      let date = new Date();
      let year = date.getFullYear();

      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      this.nowTime = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
    },
    jumpCreation() {
      window.open("https://passport.shop.jd.com/login/index.action?ReturnUrl=https%3A%2F%2Fpromo.shop.jd.com%2Fweb%2Fcoupon%2Fdetail%2Fshop%2F0%3F");
      // let routeUrl = this.$router.resolve({
      //   path: "/integralCenter/prizeCenter/coupon_management",
      // });
      // window.open(routeUrl.href, "_blank");
    },
    jumpSansCreation() {
      this.$router.push({
        name: "coupon_management",
        query: { to: 1 },
      });
    },
    jumpJingduo() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
      });
      window.open(routeUrl.href, "_blank");
    },
    jumpEkCz() {
      window.open("http://quanyi.shop.jd.com/#/eAccount");
    },
    jumpEk() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
        query: { tabAct: 3 },
      });
      window.open(routeUrl.href, "_blank");
    },
    jumpaqyCz() {
      window.open("https://quanyi.shop.jd.com/#/aiqiyiAccount");
    },
    jumpaqy() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
        query: { tabAct: 4 },
      });
      window.open(routeUrl.href, "_blank");
    },
    jumpPlusCz() {
      window.open("https://quanyi.shop.jd.com/#/plusAccount");
    },
    jumpPlus() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
        query: { tabAct: 5 },
      });
      window.open(routeUrl.href, "_blank");
    },
    jumpRedCz() {
      window.open("https://quanyi.shop.jd.com/#/redGiftAccount");
    },
    jumpRed() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
        query: { tabAct: 6 },
      });
      window.open(routeUrl.href, "_blank");
    },
    //获取店铺商品
    getShopList() {
      // this.formShopList;
      getTaobaoItemListSku(this.formShopList).then((res) => {
        this.tableShopData = res.data.records;
        this.totalListThr = Number(res.data.total);
        // console.log(res, 1111111111);
      });
    },

    getSeller() {
      // 获取商品类目
      getSellercats().then((res) => {
        let data = this.transverter(res.data);

        this.getTrees(data);

        // debugger
        let list = data.filter((item) => item.parent_id == 0);
        // console.log('list',list);
        let cascaderArr = list.map((item) => {
          return {
            label: item.label,
            value: item.value,
            children: item.children,
          };
        });
        // console.dir(cascaderArr);

        this.commodityList[0].cascaderArr = cascaderArr;
      });
      // this.$nextTick(() => {
      //   this.$refs.inputForm.formSearch();
      // });
    },
    transverter(data) {
      // 排重
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      var newData = [];
      // console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          value: arr[i].categoryId,
          parent_id: arr[i].parentId,
          label: arr[i].name,
          isChecked: false,
        };
      }
      return newData;
    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list
          .filter((o) => !parentObj[o.parent_id])
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      } else {
        return list
          .filter((o) => o.parent_id == parent_id)
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      }
    },
    //实物选择
    chooseShop(val) {
      console.log(val);
      const skuIds = [val.skuId];
      this.sureLoading = true;
      checkProduct(skuIds)
        .then((res) => {
          this.sureLoading = false;
          if (res.code == 1) {
            if (res.data.isHave) {
              this.$message.warning("活动暂不支持选择虚拟套装和影分身商品");
            } else {
              this.objectForm.logo = val.logo;
              this.objectForm.name = val.skuName.substr(0, 12);
              this.objectForm.discount = val.jdPrice;
              this.objectForm.skuId = val.skuId;
              this.objectForm.wareId = this.venderType ? val.skuId : val.wareId;
              this.objectForm.categoryId = val.categoryId;
              this.dialogFormVisible = false;
            }
          } else {
            this.$message.warning(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.sureLoading = false;
        });
      // this.objectForm.logo = val.logo;
      // this.objectForm.name = val.skuName.substr(0, 12);
      // this.objectForm.discount = val.jdPrice;
      // this.objectForm.skuId = val.skuId;
      // this.objectForm.wareId = this.venderType ? val.skuId : val.wareId;
      // this.dialogFormVisible = false;
    },
    searchContent(val) {
      this.formShopList.size = 5;
      this.formShopList.current = 1;
      if (val.categoryId) {
        this.formShopList.categoryId = val.categoryId.join(",");
      } else {
        this.formShopList.categoryId = "";
      }
      this.formShopList.skuId = val.skuId;
      this.formShopList.skuStatus = val.skuStatus;
      this.formShopList.skuName = val.skuName;
      this.getShopList();
    },
    //获取优惠券
    quireList() {
      this.dateFormat();
      // this.formList.beginTime = this.nowTime;
      couponList(this.formList).then((res) => {
        this.tableLoading = false;
        this.internalTable = res.data.records;
        this.internalTable.forEach((item) => {
          // item.couponType = 1;  //Note----bug修改
        });
        this.totalNum = Number(res.data.total);
      });
    },
    //查询外部优惠券信息
    querySellerCouponExternal() {
      this.tableLoading = true;
      querySellerCouponExternalList(this.formListTwo)
        .then((res) => {
          this.externalTable = res.data.records;
          this.externalTable.forEach((item) => {
            item.couponId = Number(item.id);
          });
          this.totalNumTwo = Number(res.data.total);
          this.tableLoading = false;
        })
        .catch((res) => {});
    },
    //输入框限制负数
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    limitInput(event) {
      // 支持输入小数点后两位
      let val = event.target.value;
      // 仅保留数字和小数点
      val = val.replace(/[^\d.]/g, "");
      // 只保留第一个小数点，去除多余的小数点
      val = val.replace(/\./, "#DOT#").replace(/\./g, "").replace(/#DOT#/, ".");
      // 限制小数点后最多两位
      val = val.replace(/(\.\d{2}).*/, "$1");
      // 整数部分去除开头多余的 0（如 01 -> 1，00.5 -> 0.5）
      val = val.replace(/^0+(\d)/, "$1");
      // 以小数点开头时自动补 0（如 .5 -> 0.5）
      val = val.replace(/^\./, "0.");

      if(this.activeName=='ten') {
        this.physicalForm.discount = val;
      } else {
        this.objectForm.discount = val;
      }

    },
    inputLimitZero(val) {
      if(Number(val.target.value)==0) {
        // 不允许输入 0
        this.$message.warning("请输入大于0的数字");
        return "";
      }else {
        return val.target.value;
      }
    },
    change(b) {
      let a = {};
      this.eKselectList.forEach((item) => {
        if (item.id == b) {
          a = item;
        }
      });
      // 原剩余份额
      this.ekForm.quantityBalance = a.quantityBalance;
      this.aqyForm.quantityBalance = a.quantityBalance;
      this.plusForm.quantityBalance = a.quantityBalance;
      // V2.5新增剩余份额
      this.ekForm.budgetRemain = a.budgetRemain;
      this.aqyForm.budgetRemain = a.budgetRemain;
      this.plusForm.budgetRemain = a.budgetRemain;
      // 单份奖品数量
      this.ekForm.num = 1;
      this.aqyForm.num = 1;
      this.plusForm.num = 1;
      console.log(this.ekForm);
    },
    change1(b) {
      let a = {};
      this.redSelectList.forEach((item) => {
        if (item.id == b) {
          a = item;
        }
      });
      this.redForm.quantityBalance = a.quantityTotal ? a.quantityTotal - a.quantityActual : ""; // 原剩余份额
      this.redForm.budgetRemain = a.budgetRemain; // V2.5新增剩余份额
      this.redForm.num = a.quantityAmount ? a.quantityAmount / a.quantityTotal : ""; // 单份奖品数量
    },
    //选择奖品弹窗
    openDialog() {
      this.dialogVisibleFrom = true;
      this.getJingdouList();
    },
    //查询京豆
    getJingdouList() {
      let params = this.venderType ? {accountCode: this.formAccount.accountCode} : {};
      let arr = []
      if(this.$parent.activityData){
        if(this.$parent.activityData.id == 36){ // 下单冲榜特殊处理
          this.$parent.editableTabs.forEach(tabs=>{
            tabs.content.forEach(item=>{
              if(item.prizeType == 2){
                if(item.assetsId != this.$parent.echoDate.assetsId){
                  arr.push(item.assetsId)
                }
              }
            })
          })
        }else if(this.$parent.activityData.id !=4 && this.$parent.activityData.id != 5){
          // 过滤出京豆计划ID
          this.$parent.itemArr.forEach(item=>{
            if(item.prizeType == 2){
              if(item.assetsId != this.$parent.echoDate.assetsId){
                arr.push(item.assetsId)
              }
            }
          })
          if(this.$parent.awardSettingsLsit){
            console.log(this.$parent.awardSettingsLsit,'this.$parent.awardSettingsLsit===>');
            this.$parent.awardSettingsLsit.forEach(item=>{
              if(item.prizeType == 2){
                if(item.assetsId != this.$parent.echoDate.assetsId){
                  arr.push(item.assetsId)
                }
              }
            })
          }
        }else{
          // 邀请关注和邀请开卡有三种奖品类型，分开处理
          // 奖品类型 0统一(awardSettingsLsit) 1梯度(itemArr) 2任务(taskTableData)
          console.log(this.$parent.ruleForm.isCumulativePrize,'this.$parent.ruleForm.isCumulativePrize===》');
          console.log(this.$parent.taskTableData,'taskTableData===》');
          console.log(this.$parent.awardSettingsLsit,'awardSettingsLsit===》');
          console.log(this.$parent.itemArr,'itemArr===》');
          if(this.$parent.ruleForm.isCumulativePrize==0){
            if(this.$parent.awardSettingsLsit){
              this.$parent.awardSettingsLsit.forEach(item=>{
                if(item.prizeType == 2){
                  if(item.assetsId != this.$parent.echoDate.assetsId){
                    arr.push(item.assetsId)
                  }
                }
              })
            }
          }else if(this.$parent.ruleForm.isCumulativePrize==1){
            this.$parent.itemArr.forEach(item=>{
              if(item.prizeType == 2){
                if(item.assetsId != this.$parent.echoDate.assetsId){
                  arr.push(item.assetsId)
                }
              }
            })
          }else if(this.$parent.ruleForm.isCumulativePrize==2){
            this.$parent.taskTableData.forEach(item=>{
              if(item.prizeType == 2){
                if(item.assetsId != this.$parent.echoDate.assetsId){
                  arr.push(item.assetsId)
                }
              }
            })
          }
        }
      }
      jingdouList({ ...this.formLitJD, activityId: this.actId ? this.actId.id : "",idList: arr,...params})
        .then((res) => {
          let selectArr = res.data.records.map((item) => {
            return {
              label: item.planName,
              value: item.id,
              sendTimes: item.sendTimes,
              budgetRemain: item.budgetRemain, // 金豆计划剩余数量
            };
          });
          this.selectList = selectArr;
          this.planList.jingdou = res.data.records;
          if(this.dialogVisibleFrom) {
            let selected = this.selectList.find((item)=>item.value==this.echoDate.assetsId)
            this.activeSendtimes = selected.sendTimes
          }
        })
        .catch((res) => {});
    },
    //京豆
    getJingdouData() {
      console.log("this.jingduoForm", this.jingduoForm);
      this.jingdouData = {
        couponId: this.jingduoForm.region.value,
        discount: Number(this.jingduoForm.count),
        name: this.jingduoForm.region.label,
        singleAmount: Number(this.jingduoForm.count),
      };
    },
    setJingdouData() {
      let jingdouPlanList = this.planList.jingdou;
      let item = jingdouPlanList.find((i) => {
        return i.id == this.jingdouData.couponId;
      });
      if (this.num == 2) {
        if (item) {
          // 梯度奖励
          if (this.$parent.ruleForm.isCumulativePrize) {
            let line = this.$parent.ruleForm.isCumulativePrize == 1 ? this.$parent.tableData[this.$parent.tableIndex] : this.$parent.taskTableData[this.$parent.taskTableIndex];
            if (
              this.jingdouData.singleAmount &&
              line.prizeCount &&
              Number(this.jingdouData.singleAmount) * Number(line.prizeCount) > Number(item.quantityTotal)
            ) {
              this.$message.error("京豆发放数量不能大于该京豆预算额！");
              return;
            }
            if (this.jingdouData.singleAmount && Number(this.jingdouData.singleAmount) > Number(item.quantityTotal)) {
              this.$message.error("单份奖励个数不能大于该京豆预算额！");
              return;
            }
            if (!this.jingdouData.singleAmount) {
              this.$message.error("请填写京豆单份奖励个数！");
              return;
            }
          } else {
            if (!this.$parent.ruleForm.peopleCount || Number(this.$parent.ruleForm.peopleCount) > 20) {
              this.$message.warning("京豆奖励需先填写最多邀请人数规则，且数目不可大于20人");
              return;
            } else if (Number(this.$parent.ruleForm.peopleCount) > item.sendTimes) {
              this.$message.error("奖品发放规则与京豆计划的发豆规则不一致，会导致奖品发放失败，请重新选择京豆计划～");
              return;
            }
            if (
              Number(this.$parent.ruleForm.prizeCount) &&
              this.jingdouData.singleAmount &&
              Number(this.$parent.ruleForm.prizeCount) * Number(this.jingdouData.singleAmount) > Number(item.quantityTotal)
            ) {
              this.$message.error("京豆发放数量不能大于该京豆预算额！");
              return;
            }
            if (this.jingdouData.singleAmount && Number(this.jingdouData.singleAmount) > Number(item.quantityTotal)) {
              this.$message.error("单份奖励个数不能大于该京豆预算额！");
              return;
            }
            if (!this.jingdouData.singleAmount) {
              this.$message.error("请填写京豆单份奖励个数！");
              return;
            }
          }
        }
      } else {
        let line = this.JingdouCount;
        if (item) {
          if (
            line.prizeCount &&
            this.jingdouData.singleAmount &&
            Number(line.prizeCount) * Number(this.jingdouData.singleAmount) > Number(item.quantityTotal)
          ) {
            this.$message.error("京豆发放数量不能大于该京豆预算额！");
            return;
          }
          if (this.jingdouData.singleAmount && Number(this.jingdouData.singleAmount) > Number(item.quantityTotal)) {
            this.$message.error("单份奖励个数不能大于该京豆预算额！");
            return;
          }
          if (!this.jingdouData.singleAmount) {
            this.$message.error("请填写京豆单份奖励个数！");
            return;
          }
        }
      }
      // if (this.jingdouData.singleAmount&&Math.ceil(this.jingdouData.singleAmount/1000)>Number(this.activeSendtimes)) {
      //   this.$message.error("因官方接口限制，单次发豆数量上限是1000，超过时会分多次发放，为确保发放成功，京豆计划发放次数必大于等于单份奖励个数/1000，请重新选择京豆计划或者调整单份奖励个数");
      //   return;
      // }

      // return
      this.dialogVisibleFrom = false;
      // this.jingdouData.couponId()
      this.$emit("choose-shop", { ...this.jingdouData, quantityTotal: item.quantityTotal, name: `${this.jingdouData.discount}京豆`,budgetRemain:item.budgetRemain }, 2);
    },
    //查询京东E卡,爱奇艺会员,京豆PLUS会员
    async acquireAssets() {
      let res = await allAccountList({ ...this.formLitZC, activityId: this.actId ? this.actId.id : "" });
      let selectArr = res.data.records.map((item) => {
        return {
          ...item,
          label: item.planName,
        };
      });
      // let selectArr = [
      //   {budgetRemain:9,label:"京东E卡50元14",planName:"京东E卡50元14",quantityBalance:9,id:'148',itemId:5},
      //   {budgetRemain:11,label:"京东E卡50元14",planName:"京东E卡50元14",quantityBalance:11,id:'149',itemId:5},
      //   {budgetRemain:12,label:"京东E卡50元14",planName:"京东E卡50元14",quantityBalance:12,id:'147',itemId:5},
      //   {budgetRemain:13,label:"京东E卡50元14",planName:"京东E卡50元14",quantityBalance:13,id:'146',itemId:5},
      // ]
      // 获取当前活动已使用计划的ID
      let arr5 = [],arr6 = [],arr7 = [];
      if(this.$parent.activityData){
        if(this.$parent.activityData.id == 36){ // 下单冲榜特殊处理
          this.$parent.editableTabs.forEach(tabs=>{
            tabs.content.forEach(item=>{
              if(item.assetsId != this.$parent.echoDate.assetsId){
                if(item.prizeType == 5) arr5.push(item.assetsId)
                if(item.prizeType == 6) arr6.push(item.assetsId)
                if(item.prizeType == 7) arr7.push(item.assetsId)
              }
            })
          })
        }else if(this.$parent.activityData.id !=4 && this.$parent.activityData.id != 5){
          this.$parent.itemArr.forEach(item=>{
            if(item.assetsId != this.$parent.echoDate.assetsId){
              if(item.prizeType == 5) arr5.push(item.assetsId)
              if(item.prizeType == 6) arr6.push(item.assetsId)
              if(item.prizeType == 7) arr7.push(item.assetsId)
            }
          })
          if(this.$parent.awardSettingsLsit){
            this.$parent.awardSettingsLsit.forEach(item=>{
              if(item.assetsId != this.$parent.echoDate.assetsId){
                if(item.prizeType == 5) arr5.push(item.assetsId)
                if(item.prizeType == 6) arr6.push(item.assetsId)
                if(item.prizeType == 7) arr7.push(item.assetsId)
              }
            })
          }
        }else{
          // 邀请关注和邀请开卡有三种奖品类型，分开处理
          if(this.$parent.ruleForm.isCumulativePrize==0){
            if(this.$parent.awardSettingsLsit){
              this.$parent.awardSettingsLsit.forEach(item=>{
                if(item.assetsId != this.$parent.echoDate.assetsId){
                  if(item.prizeType == 5) arr5.push(item.assetsId)
                  if(item.prizeType == 6) arr6.push(item.assetsId)
                  if(item.prizeType == 7) arr7.push(item.assetsId)
                }
              })
            }
          }else if(this.$parent.ruleForm.isCumulativePrize==1){
            this.$parent.itemArr.forEach(item=>{
              if(item.assetsId != this.$parent.echoDate.assetsId){
                if(item.prizeType == 5) arr5.push(item.assetsId)
                if(item.prizeType == 6) arr6.push(item.assetsId)
                if(item.prizeType == 7) arr7.push(item.assetsId)
              }
            })
          }else if(this.$parent.ruleForm.isCumulativePrize==2){
            this.$parent.taskTableData.forEach(item=>{
              if(item.assetsId != this.$parent.echoDate.assetsId){
                if(item.prizeType == 5) arr5.push(item.assetsId)
                if(item.prizeType == 6) arr6.push(item.assetsId)
                if(item.prizeType == 7) arr7.push(item.assetsId)
              }
            })
          }
        }
      }
      console.log("arr5,arr6,arr7",arr5,arr6,arr7);
      // 过滤出当前活动未使用的计划
      if(this.formLitZC.assetType == 5){ // 京东E卡
        selectArr = selectArr.filter(item=>!arr5.includes(Number(item.id))) 
      }else if(this.formLitZC.assetType == 6){  // 爱奇艺会员
        selectArr = selectArr.filter(item=>!arr6.includes(Number(item.id))) 
      }else if(this.formLitZC.assetType == 7){ // 京东plus
        selectArr = selectArr.filter(item=>!arr7.includes(Number(item.id))) 
      }
      console.log(selectArr);
      this.eKselectList = selectArr;
    },
    //查询红包
    async redBag() {
      let res = await redPacketList({ ...this.formLitRed, activityId: this.actId ? this.actId.id : "" });
      let selectArr = res.data.records.map((item) => {
        return {
          ...item,
          label: item.planName,
        };
      });
      // let selectArr = [
      //   {budgetRemain:9,label:"京东E卡50元14",quantityAmount:100,quantityTotal:20,id:'148'},
      //   {budgetRemain:11,label:"京东E卡50元14",quantityAmount:20,quantityTotal:10,id:'149'},
      //   {budgetRemain:12,label:"京东E卡50元14",quantityAmount:50,quantityTotal:5,id:'147'},
      //   {budgetRemain:13,label:"京东E卡50元14",quantityAmount:10,quantityTotal:2,id:'146'},
      // ]
      let arr = []
      if(this.$parent.activityData){
        if(this.$parent.activityData.id !=4 && this.$parent.activityData.id != 5){
          this.$parent.itemArr.forEach(item=>{
            if(item.assetsId != this.$parent.echoDate.assetsId){
              if(item.prizeType == 8) arr.push(item.assetsId)
            }
          })
          if(this.$parent.awardSettingsLsit){
            this.$parent.awardSettingsLsit.forEach(item=>{
              if(item.assetsId != this.$parent.echoDate.assetsId){
                if(item.prizeType == 8) arr.push(item.assetsId)
              }
            })
          }
        }else{
          // 邀请关注和邀请开卡有三种奖品类型，分开处理
          if(this.$parent.ruleForm.isCumulativePrize==0){
            if(this.$parent.awardSettingsLsit){
              this.$parent.awardSettingsLsit.forEach(item=>{
                if(item.assetsId != this.$parent.echoDate.assetsId){
                  if(item.prizeType == 8) arr.push(item.assetsId)
                }
              })
            }
          }else if(this.$parent.ruleForm.isCumulativePrize==1){
            this.$parent.itemArr.forEach(item=>{
              if(item.assetsId != this.$parent.echoDate.assetsId){
                if(item.prizeType == 8) arr.push(item.assetsId)
              }
            })
          }else if(this.$parent.ruleForm.isCumulativePrize==2){
            this.$parent.taskTableData.forEach(item=>{
              if(item.assetsId != this.$parent.echoDate.assetsId){
                if(item.prizeType == 8) arr.push(item.assetsId)
              }
            })
          }
        }
      }
      console.log("arr",arr);
      // 过滤出当前活动未使用的计划
      this.redSelectList = selectArr.filter(item=>!arr.includes(Number(item.id)))
    },
    async handleClick(tab, event) {
      if (tab.name == "first") {
        this.formLitZC.assetType = 1;
      }
      if (tab.name == "second") {
        this.formLitZC.assetType = 2;
        this.jingduoForm.count = ""; //京豆
      }
      if (tab.name == "third") {
        this.formLitZC.assetType = 3; //实物
        this.objectForm.resource = "1";
        this.objectForm.name = "";
        this.objectForm.discount = "";
        this.objectForm.logo = "";
        if(this.activityType=='8') {
          this.deliveryInfo.addressFillEndTime = this.endTime;
          this.deliveryTime = this.endTime;
        }
      }
      if (tab.name == "four") {
        this.formLitZC.assetType = 4; //店铺积分
        this.integralForm.discount = "";
      }
      if (tab.name == "fird") {
        this.formLitZC.assetType = 5; //E卡
        this.ekForm.region = "";
        this.ekForm.quantityBalance = "";
        this.ekForm.budgetRemain = "";
        this.ekForm.num = "";
        this.eKselectList = []
        await this.acquireAssets();
      } else if (tab.name == "six") {
        this.formLitZC.assetType = 6; //爱奇艺会员
        this.aqyForm.region = ""
        this.aqyForm.quantityBalance = "";
        this.aqyForm.budgetRemain = "";
        this.aqyForm.num = "";
        this.eKselectList = []
        await this.acquireAssets();
      } else if (tab.name == "sev") {
        this.formLitZC.assetType = 7; //PLUS会员
        this.plusForm.region = "";
        this.plusForm.quantityBalance = "";
        this.plusForm.budgetRemain = "";
        this.plusForm.num = "";
        this.eKselectList = []
        await this.acquireAssets();
      }
      if (tab.name == "eig") {
        this.formLitZC.assetType = 8; //现金红包
        this.redForm.region = "";
        this.redForm.budgetRemain = "";
        this.redForm.num = "";
        this.redSelectList = []
        await this.redBag();
      }
      if (tab.name == "nine") {
        this.formLitZC.assetType = 10; //礼品卡
        this.giftCardForm.region = "";
        this.giftCardForm.logo = "";
        this.giftCardForm.budgetRemain = "";
        this.giftCardForm.num = "";
        await this.getGiftCardList()
        this.isShowGift = true
      }
      if (tab.name == "ten") {
        this.formLitZC.assetType = 3; //实物（实物管理）
        this.physicalForm.region = "";
        this.physicalForm.budgetRemain = "";
        this.physicalForm.discount = "";
        this.physicalForm.logo = "";
        this.physicalForm.name = "";
        this.physicalForm.isGoodManage = 1
        await this.getPhysical()
      }
      // console.log(tab.index, this.tabActive);
    },
    handleClickTwo(tab, event) {
      if (tab.name == "second") {
        this.querySellerCouponExternal();
      } else {
        // console.log(222);
      }
    },
    searchForm(val) {
      this.formList.type = val.type;
      this.formList.display = val.display;
      this.formList.grantType = val.grantType;
      this.quireList();
    },
    searchFormTwo(val) {
      this.formListTwo.name = val.name;
      this.formListTwo.discount = val.discount;
      this.formListTwo.issueType = val.issueType;
      this.querySellerCouponExternal();
    },
    chooseTab(val) {
      val.singleAmount = 1;
      val.name = val.numPerSending + '张' + val.discount + "元优惠券";
      val.id = val.assetsId
      val.couponId = val.assetsId
      console.log(val,'val;')
      this.$emit("choose-shop", val, 1);
    },
    storePoint() {
      this.integralForm.singleAmount = this.integralForm.discount;
      this.$emit("choose-shop", this.integralForm, 4);
    },
    jingDonData() {
      if (this.formLitZC.assetType == 5) {
        let obj = {};
        this.eKselectList.forEach((item) => {
          if (item.id == this.ekForm.region) {
            obj = item;
          }
        });
        //E卡
        this.zcData = {
          couponId: this.ekForm.region,
          discount: parseFloat(obj.quota),
          name: this.nameStr(1, obj.itemId),
          budgetRemain: obj.budgetRemain,
          singleAmount: 1,
        };
      } else if (this.formLitZC.assetType == 6) {
        let obj = {};
        this.eKselectList.forEach((item) => {
          console.log(item.id, this.aqyForm.region, 1111);
          if (item.id == this.aqyForm.region) {
            obj = item;
          }
        });
        console.log(this.eKselectList);
        console.log(obj, this.aqyForm.region, 6666);
        //爱奇艺会员
        this.zcData = {
          couponId: this.aqyForm.region,
          discount: obj.quota,
          name: this.nameStr(3, obj.itemId),
          budgetRemain: obj.budgetRemain,
          singleAmount: 1,
        };
      } else if (this.formLitZC.assetType == 7) {
        let obj = {};
        this.eKselectList.forEach((item) => {
          if (item.id == this.plusForm.region) {
            obj = item;
          }
        });
        //PLUS会员
        this.zcData = {
          couponId: this.plusForm.region,
          discount: obj.quota,
          name: this.nameStr(2, obj.itemId),
          budgetRemain: obj.budgetRemain,
          singleAmount: 1,
        };
      }
      // console.log(this.zcData, 222);
    },
    // 现金红包设置
    redData() {
      let obj = {};
      this.redSelectList.forEach((item) => {
        if (item.id == this.redForm.region) {
          obj = item;
        }
      });

      this.zcData = {
        couponId: this.redForm.region,
        discount: this.redForm.num,
        name: obj.label,
        singleAmount: 1,
        budgetRemain: obj.budgetRemain,
      };
    },
    // 礼品卡设置
    handleGetGiftCard(row) {
      let obj = {};
      this.giftCardList.some((item) => {
        if (item.id == row.region) {
          obj = item;
        }
      });
      this.zcData = {
        couponId: row.region,
        discount: row.num,
        name: row.name,
        logo: row.logo,
        singleAmount: 1,
        budgetRemain: row.budgetRemain
      };
      this.isShowGift = false
      this.jingDonEka(10)
    },
    changeJP() {
      this.zcData = {
        giftType: this.objectForm.resource,
        logo: this.objectForm.logo,
        couponId: this.objectForm.wareId,
        discount: this.objectForm.discount.toString().replace(/[^\d.-]/g, ''),
        name: this.objectForm.name,
        singleAmount: 1,
        skuId: this.objectForm.skuId,
        categoryId: this.objectForm.categoryId,
      };
      if(this.objectForm.resource == 2){
        delete this.zcData.skuId
        delete this.zcData.couponId
      }
      if (this.activityType=='8') {
        this.zcData = {
          ...this.zcData,
          ...this.deliveryInfo
        };
      }
      if (this.activityType=='36') {
        if(this.attachInfo.shouldCollectExtraData==1) {
        const isHasTitle = this.attachInfo.questions.some((item)=>item.title)
        if(!isHasTitle) {
          this.$message.warning("请设置附加信息")
            return
          }
        }
        this.zcData = {
          ...this.zcData,
          shouldCollectExtraData: this.attachInfo.shouldCollectExtraData,
          extraQuestion: this.attachInfo.shouldCollectExtraData==1 ? this.attachInfo.questions[0] : null
        };
      }
      this.dialogVisibleFrom = false;
      console.log(this.objectForm,'选择实物');
      this.$emit("choose-shop", this.zcData, 3);
    },
    resetPhysical(){
      this.getPhysical()
    },
    createPhysical() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/goods_management"
      });
      window.open(routeUrl.href, "_blank");
    },
     // 实物（实物管理）获取剩余份数
    handleChangePhysical(id) {
      let obj = this.physicalList.find(item=>item.id == id);
      this.physicalForm.region = obj.id
      this.physicalForm.logo = obj.image
      this.physicalForm.name = obj.goodsName
      this.physicalForm.budgetRemain = obj.inventoryType ==1 ? "" : obj.budgetRemain,
      this.physicalForm.inventoryType = obj.inventoryType
    },
    changePhysical() {
      this.zcData = {
        logo: this.physicalForm.logo,
        discount: this.physicalForm.discount,
        name: this.physicalForm.name,
        couponId: this.physicalForm.region,
        isGoodManage: 1,
        singleAmount: 1,
        giftType: '1',
        budgetRemain: this.physicalForm.inventoryType==1 ? "" : this.physicalForm.budgetRemain
      };
      this.dialogVisibleFrom = false;
      this.jingDonEka(3,1)
      // this.$emit("choose-shop", this.zcData, 3);
    },
    nameStr(type, val) {
      let obj = {};
      if (type == 1) {
        obj = {
          2: "1元京东E卡",
          3: "5元京东E卡",
          4: "20元京东E卡",
          5: "50元京东E卡",
          6: "100元京东E卡",
        };
      }
      if (type == 2) {
        obj = {
          7: "PLUS会员年卡",
        };
      }
      if (type == 3) {
        obj = {
          8: "爱奇艺会员月卡",
          12: "爱奇艺会员季卡",
          13: "爱奇艺会员半年卡",
          14: "爱奇艺会员年卡",
        };
      }
      return obj[val];
    },
    jingDonEka(type,isGoodManage) {
      let item;
      if(type == 8){
        item = this.redSelectList.find((i) => {
          return i.id == this.zcData.couponId;
        });
      } else if(type == 10){
        item = this.giftCardList.find((i) => {
          return i.id == this.zcData.couponId;
        });
      } else if(type == 3&&isGoodManage==1){
        item = this.physicalList.find((i) => {
          return i.id == this.zcData.couponId;
        });
      }else{
        item = this.eKselectList.find((i) => {
          return i.id == this.zcData.couponId;
        });
      }
      if(this.num == 2){
        if(item){
          // 梯度奖励
          if (this.$parent.ruleForm.isCumulativePrize) {
            let line = this.$parent.ruleForm.isCumulativePrize == 1 ? this.$parent.tableData[this.$parent.tableIndex] : this.$parent.taskTableData[this.$parent.taskTableIndex];
            if (line.prizeCount && Number(line.prizeCount) > Number(item.budgetRemain)){
              this.messageLog(type)
              return;
            }
          } else {
            if (Number(this.$parent.ruleForm.prizeCount) && Number(this.$parent.ruleForm.prizeCount) > Number(item.budgetRemain)) {
              this.messageLog(type)
              return;
            }
          }
        }
      }else{
        let line = this.JingdouCount;
        if (item) {
          if (line.prizeCount && Number(line.prizeCount) > Number(item.budgetRemain)) {
            this.messageLog(type)
            return;
          }
        }
      }
      this.dialogVisibleFrom = false
      if(type == 8){
        this.$emit("choose-shop", { ...this.zcData, name: `${this.zcData.discount}元现金红包` }, 8);
      }else{
        this.$emit("choose-shop", { ...this.zcData }, type);
      }
    },
    messageLog(type){
      if(type == 5) this.$message.error("京东E卡总份额数量不能大于该京东E卡剩余预算额！")
      if(type == 6) this.$message.error("爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！")
      if(type == 7) this.$message.error("京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！")
      if(type == 8) this.$message.error("现金红包总份额数量不能大于该现金红包剩余预算额！")
      if(type == 10) this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！")
    },
    redList() {
      this.dialogVisibleFrom = false
      this.$emit("choose-shop", { ...this.zcData, name: `${this.zcData.discount}元现金红包` }, 8);
    },
    //上传图片
    handleChange(file, fileList) {
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 300K");
        this.$refs.upload.clearFiles();
      } else {
        this.fileList = fileList;

        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.objectForm.logo = res.data;
        });
      }
    },

    handleRemove(file, fileList) {
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      // this.imageName = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    httpRequest() {},
    //分页事件
    handleSizeChange(val) {
      this.formList.size = val;
      this.quireList();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.quireList();
    },
    handleSizeChangeTwo(val) {
      this.formListTwo.size = val;
      this.querySellerCouponExternal();
    },
    handleCurrentChangeTwo(val) {
      this.formListTwo.current = val;
      this.querySellerCouponExternal();
    },
    //分页事件
    handleSizeChangeThr(val) {
      this.formShopList.size = val;
      this.getShopList();
    },
    handleCurrentChangeThr(val) {
      this.formShopList.current = val;
      this.getShopList();
    },
  },
};
</script>

<style scoped lang="scss">
.Notetake {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #7b61ff;
  }
}
.topTis {
  display: flex;
  align-items: baseline;
  color: #333;
  font-size: 14px;
  background: #f4f7ff;
  margin: 24px;
  padding: 12px;
  color: #333;
  margin-left: 0px;
  .desc {
    line-height: 20px;
  }
  p {
    margin-left: 5px;
    line-height: 20px;
  }
  .topTis_line {
    line-height: 25px;
    font-size: 12px;
  }
}
.cancel {
  width: 164px;
  // margin-right: 8px;
  color: #7b61ff;
  border: 1px solid #7b61ff;
  background: rgba(123, 97, 255, 0.1);
  // &:hover {
  //   color: #7b61ff;
  //   border: 1px solid #7b61ff;
  //   background: rgba(123, 97, 255, 0.1);
  // }
}
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 9px 14px;
  display: flex;
  .card-rule {
    background: url("../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}
.ml4 {
  margin-left: 4px;
}

.my_select_time1 {
  position: relative;
  display: inline-block;

  .time1 {
   /deep/.el-input__inner {
      padding: 0 4px !important;
    }
    /deep/.el-input input {
      background: #f5f5f7;
      color: #999999;
      border-radius: 2px;
    }

    /deep/.el-input input:focus {
      background: #ffff;
      color: #333333;
    }
  }

  .date_icon2,
  .date_icon1 {
    position: absolute;
    right: 5px;
    height: 32px;
    line-height: 32px;
    width: 16px;
    font-size: 16px;
  }

  .date_icon1 {
    display: none;
    cursor: pointer;
  }
}
.my_select_time1:hover {
  .date_icon2 {
    display: none;
  }

  .date_icon1 {
    display: inline-block;
  }
}
</style>
